<template>
    <div class="community-detail">
        <div class="position-fixed bottom-0 end-0 p-3" style="z-index: 1090">
            <div id="toastNotice" class="toast" role="alert" aria-live="assertive" aria-atomic="true">
                <div class="toast-body">已複製到剪貼簿</div>
            </div>
        </div>
        <div class="position-fixed bottom-0 end-0 p-3" style="z-index: 1090;">
            <div id="toastErrorReporting" class="toast" role="alert" aria-live="assertive" aria-atomic="true">
                <div class="toast-body">
                    <p>感謝你的貢獻！</p>
                    你的回饋可以讓我們提供<br>
                    更正確的資料
                </div>
            </div>
        </div>

        <div class="house-page community-page">
            <div class="row sticky-zone" id="stickyZone">
                <nav class="sticky-nav" id="stickySpy" :style="(scroll >= infoOffsetTop ? '' : 'display:none;')">
                    <div class="container p-0">
                        <ul class="nav nav-pills">
                            <li class="nav-item">
                                <a class="nav-link" href="#realPrice">實價登錄</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#similarHouse">待售房屋</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#communityInfo">社區資料</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#mapAnchor">生活地圖</a>
                            </li>
<!--                            <li class="nav-item">-->
<!--                                <a class="nav-link" href="#nearCommunityList">附近社區</a>-->
<!--                            </li>-->
                        </ul>
                    </div>
                </nav>
                <section class="house-container">
                    <div class="container d-flex d-md-block flex-column">
                        <div class="up__comm mb-lg-3 mt-lg-5">
                            <p class="share mb-0 d-flex justify-content-end">
                                <a href="#0" data-bs-toggle="modal" data-bs-target="#questionModal"
                                   class="share_modal error-reporting-margin-right d-flex align-items-center">
                                    <span class="icon-1 me-1"><IconQuestion/></span>回報錯誤
                                </a>
                                <a href="#0" data-bs-toggle="modal" data-bs-target="#sharetoModal" class="share_modal d-flex align-items-center">
                                    <span class="icon-2 me-1"><IconShare/></span>分享
                                </a>
                            </p>
                        </div>
                        <div class="slider-header d-lg-flex flex-wrap">
                            <div class="slider-gallery">
                                <div class="slider-for">
                                    <div class="item" v-for="(img, index) in community.img">
                                        <div class="ratio-comm-cover ratio">
                                            <img :src="img" :style="isShow ? '' : 'display: none;'">
                                        </div>
                                    </div>
                                </div>
                                <div class="slider-nav">
                                    <div class="item" v-for="(img, index) in community.img">
                                        <div class="ratio-comm-nav ratio">
                                            <img :src="img">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="slider-info mb-1">
                                <div class="list-heading mb-2">
                                    <div class="list-top d-flex align-items-center mb-2">
                                        <h1 class="mb-0">{{ community.title }}</h1>
                                        <div class="sale-tag ms-3">{{ community.salesItem }} <span class="small">筆待售</span></div>
                                    </div>
                                    <div class="address">{{ community.address }}</div>
                                </div>
                                <div class="slider-info-inner">
                                    <div class="list-body first pb-2 mb-3 d-none d-lg-block">
                                        <div class="info-lists row g-0">
                                            <div class="info-group col"><span class="title">戶數</span><span>{{ community.household }}戶</span></div>
                                            <div class="info-group col"><span class="title">樓層</span><span>{{ community.floor }}樓</span></div>
                                        </div>
                                        <div class="info-lists row g-0">
                                            <div class="info-group col"><span class="title">屋齡</span><span>{{ community.age }}年</span></div>
                                            <div class="info-group col"><span class="title">型態</span><span>{{ community.communityType }}</span></div>
                                        </div>
                                        <div class="info-lists row g-0">
                                            <div class="info-group col"><span class="title">坪數</span><span>{{ community.ping }}坪</span></div>
                                        </div>
                                    </div>
                                    <div class="list-body d-block d-lg-none">
                                        <div class="row info-lists">
                                            <div class="info-group col-12 col-md-4"><span class="title">戶數</span><span>{{ community.household }}戶</span></div>
                                            <div class="info-group col-12 col-md-4"><span class="title">樓層</span><span>{{ community.floor }}樓</span></div>
                                            <div class="info-group col-12 col-md-4"><span class="title">屋齡</span><span>{{ community.age }}年</span></div>
                                            <div class="info-group col-12 col-md-4"><span class="title">型態</span><span>{{ community.communityType }}</span></div>
                                            <div class="info-group col-12 col-md-4"><span class="title">坪數</span><span>{{ community.ping }}坪</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="store-info-group keiuoe">
                                        <div class="list-body store-info">
                                            <div class="list-heading">
                                                <div class="list-top d-flex d-lg-block">
                                                    <h2 class="mb-1 mb-lg-3">社區專家</h2>
                                                    <span class="d-block d-lg-none mx-2">-</span>
                                                    <p class="mb-1 mb-lg-2"> {{ community.branchName }}</p>
                                                </div>
                                                <p class="address mb-0 mb-lg-3 text-truncate">
                                                    <i class="icon">
                                                        <IconPin/>
                                                    </i> {{ community.officeAddress }}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="btn-wrapper">
                                            <div class="mb-0 me-2 mb-lg-2 me-lg-0 w-100">
                                                <a :href="'tel:' + community.officeTel" class="btn btn-primary w-100 btn-lg mb-lg-3"
                                                   v-if="community.officeTel != ''">
                                                    <i class="icon me-0 me-md-1 icon-phone">
                                                        <IconPhone/>
                                                    </i>
                                                    <span class="text">{{ community.officeTel }}</span>
                                                </a>
                                                <a :href="community.lineUrl" target="_blank" class="btn btn-line w-100 btn-lg"
                                                   v-if="community.lineUri != ''">
                                                    <i class="icon me-0 me-md-1">
                                                        <IconLine/>
                                                    </i>
                                                    <span class="text">用LINE聯絡</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="realPrice" class="house-info-block">
                    <div class="container">
                        <h2 class="section_info-title d-flex align-items-center mb-3">
                            <i class="icon"><img src="../assets/images/icon-actual.svg" class="w-100" alt=""></i> 實價登錄
                        </h2>
                        <div class="detail_content2" v-if="community.realPriceTotal > 0">
                            <p>最新實價登錄</p>
                            <div class="row g-3">
                                <div class="col-6 col-md-3">
                                    <div class="card-actual">
                                        <h3>平均成交價</h3>
                                        <div class="price">
                                            <span class="text-danger value">{{ community.realPriceStatistics.aveTransactionPrice }}</span>
                                            <small>萬</small>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6 col-md-3">
                                    <div class="card-actual">
                                        <h3>最新成交價</h3>
                                        <div class="price">
                                            <span class="text-danger value">{{ community.realPriceStatistics.newestTransactionPrice }}</span>
                                            <small>萬</small>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6 col-md-3">
                                    <div class="card-actual">
                                        <h3>歷史最高價</h3>
                                        <div class="price">
                                            <span class="value">{{ community.realPriceStatistics.highestTransactionPrice }}</span>
                                            <small>萬</small>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6 col-md-3">
                                    <div class="card-actual">
                                        <h3>歷史最低價</h3>
                                        <div class="price">
                                            <span class="value">{{ community.realPriceStatistics.lowestTransactionPrice }}</span>
                                            <small>萬</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="out-bg-gray">
                        <div class="container">
                            <div class="none-real-price-svg d-none d-lg-block" v-if="community.realPriceTotal == 0">
                                <div class="row">
                                    <div class="col-6">
                                        <svg width="483" height="304" viewBox="0 0 483 304" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_3038_44050)">
                                                <path
                                                    d="M167.3 289.188C166.923 289.205 166.549 289.106 166.23 288.903C165.911 288.701 165.662 288.404 165.516 288.055C165.37 287.705 165.335 287.319 165.416 286.948C165.496 286.578 165.688 286.241 165.965 285.984L166.091 285.48C166.075 285.44 166.058 285.4 166.041 285.359C165.661 284.458 165.024 283.69 164.21 283.151C163.397 282.612 162.442 282.327 161.467 282.33C160.492 282.334 159.54 282.627 158.73 283.172C157.921 283.717 157.289 284.49 156.916 285.393C155.423 289.001 153.523 292.614 153.055 296.428C152.849 298.114 152.936 299.823 153.312 301.479C149.807 293.806 147.986 285.465 147.975 277.024C147.974 274.905 148.091 272.789 148.326 270.683C148.52 268.958 148.789 267.244 149.134 265.543C151.012 256.312 155.046 247.66 160.904 240.298C163.739 238.745 166.032 236.358 167.474 233.458C167.996 232.415 168.365 231.302 168.57 230.154C168.25 230.196 167.364 225.308 167.605 225.008C167.159 224.329 166.361 223.992 165.875 223.329C163.454 220.035 160.118 220.61 158.377 225.087C154.657 226.971 154.621 230.095 156.904 233.1C158.356 235.012 158.555 237.599 159.829 239.645C159.698 239.814 159.562 239.977 159.431 240.145C157.035 243.237 154.946 246.557 153.196 250.058C153.621 246.136 153.113 242.169 151.713 238.483C150.294 235.047 147.634 232.154 145.292 229.184C142.478 225.616 136.709 227.173 136.213 231.695C136.208 231.739 136.203 231.783 136.199 231.827C136.547 232.024 136.887 232.233 137.221 232.454C137.639 232.735 137.964 233.136 138.151 233.604C138.339 234.073 138.381 234.588 138.272 235.081C138.163 235.575 137.908 236.023 137.541 236.369C137.174 236.714 136.711 236.94 136.213 237.017L136.162 237.025C136.286 238.284 136.505 239.531 136.818 240.756C133.813 252.418 140.3 256.665 149.563 256.856C149.768 256.961 149.967 257.066 150.172 257.166C148.413 262.169 147.309 267.379 146.89 272.667C146.652 275.787 146.666 278.921 146.931 282.038L146.916 281.927C146.245 278.461 144.402 275.333 141.699 273.072C137.684 269.763 132.012 268.544 127.681 265.884C127.221 265.587 126.686 265.429 126.139 265.428C125.592 265.426 125.056 265.582 124.594 265.876C124.132 266.17 123.764 266.591 123.533 267.089C123.301 267.586 123.217 268.139 123.289 268.684C123.294 268.722 123.3 268.761 123.306 268.8C123.952 269.064 124.581 269.368 125.188 269.71C125.536 269.907 125.877 270.116 126.21 270.337C126.629 270.618 126.953 271.019 127.141 271.488C127.328 271.957 127.371 272.471 127.262 272.965C127.153 273.458 126.898 273.907 126.53 274.252C126.163 274.598 125.7 274.824 125.203 274.901L125.152 274.908C125.115 274.914 125.084 274.919 125.047 274.924C126.15 277.568 127.698 280.001 129.624 282.117C131.503 292.297 139.573 293.263 148.205 290.299H148.211C149.158 294.429 150.53 298.449 152.306 302.295H166.934C166.986 302.132 167.033 301.963 167.081 301.8C165.727 301.886 164.367 301.804 163.033 301.558C164.118 300.222 165.203 298.875 166.289 297.538C166.313 297.514 166.336 297.487 166.357 297.46C166.908 296.776 167.463 296.097 168.014 295.413L168.014 295.412C168.043 293.315 167.804 291.224 167.301 289.188L167.3 289.188Z"
                                                    fill="#F2F2F2"/>
                                                <path
                                                    d="M344.929 153.778H11.2154C8.24198 153.775 5.39128 152.588 3.28872 150.478C1.18616 148.368 0.00343513 145.507 0 142.523V11.255C0.00343513 8.27108 1.18616 5.41032 3.28872 3.30034C5.39128 1.19035 8.24198 0.00344726 11.2154 0H344.929C347.903 0.00344726 350.753 1.19035 352.856 3.30034C354.958 5.41032 356.141 8.27108 356.145 11.255V142.523C356.141 145.507 354.958 148.368 352.856 150.478C350.753 152.588 347.903 153.775 344.929 153.778Z"
                                                    fill="#F2F2F2"/>
                                                <path
                                                    d="M267.099 146.599H64.1869C49.0661 146.582 34.5696 140.547 23.8776 129.817C13.1856 119.087 7.17136 104.539 7.1543 89.3653V64.418C7.17134 49.2438 13.1856 34.696 23.8776 23.9662C34.5695 13.2364 49.0661 7.20081 64.1869 7.18359H291.959C307.079 7.2008 321.576 13.2364 332.268 23.9662C342.96 34.696 348.974 49.2438 348.991 64.418C348.967 86.2062 340.331 107.095 324.978 122.502C309.626 137.908 288.811 146.575 267.099 146.599Z"
                                                    fill="white"/>
                                                <path
                                                    d="M214.756 44.7624H80.6288C79.8617 44.7624 79.1259 44.4566 78.5835 43.9122C78.0411 43.3678 77.7363 42.6295 77.7363 41.8597C77.7363 41.0899 78.0411 40.3516 78.5835 39.8072C79.1259 39.2628 79.8617 38.957 80.6288 38.957H214.756C215.523 38.957 216.259 39.2628 216.802 39.8072C217.344 40.3516 217.649 41.0899 217.649 41.8597C217.649 42.6295 217.344 43.3678 216.802 43.9122C216.259 44.4566 215.523 44.7624 214.756 44.7624Z"
                                                    fill="#E6E6E6"/>
                                                <path
                                                    d="M282.654 75.7311H80.6288C79.8617 75.7311 79.1259 75.4253 78.5835 74.881C78.0411 74.3366 77.7363 73.5983 77.7363 72.8285C77.7363 72.0586 78.0411 71.3203 78.5835 70.776C79.1259 70.2316 79.8617 69.9258 80.6288 69.9258H282.654C283.421 69.9258 284.157 70.2316 284.699 70.776C285.242 71.3203 285.546 72.0586 285.546 72.8285C285.546 73.5983 285.242 74.3366 284.699 74.881C284.157 75.4253 283.421 75.7311 282.654 75.7311Z"
                                                    fill="#E6E6E6"/>
                                                <path
                                                    d="M282.654 106.702H80.6288C79.8617 106.702 79.1259 106.396 78.5835 105.852C78.0411 105.307 77.7363 104.569 77.7363 103.799C77.7363 103.029 78.0411 102.291 78.5835 101.747C79.1259 101.202 79.8617 100.896 80.6288 100.896H282.654C283.421 100.896 284.157 101.202 284.699 101.747C285.242 102.291 285.546 103.029 285.546 103.799C285.546 104.569 285.242 105.307 284.699 105.852C284.157 106.396 283.421 106.702 282.654 106.702Z"
                                                    fill="#E6E6E6"/>
                                                <path
                                                    d="M282.654 106.702H80.6288C79.8617 106.702 79.1259 106.396 78.5835 105.852C78.0411 105.307 77.7363 104.569 77.7363 103.799C77.7363 103.029 78.0411 102.291 78.5835 101.747C79.1259 101.202 79.8617 100.896 80.6288 100.896H282.654C283.421 100.896 284.157 101.202 284.699 101.747C285.242 102.291 285.546 103.029 285.546 103.799C285.546 104.569 285.242 105.307 284.699 105.852C284.157 106.396 283.421 106.702 282.654 106.702Z"
                                                    fill="#E6E6E6"/>
                                                <path
                                                    d="M263.1 53.4304C264.949 43.3147 269.273 34.458 276.873 27.2691C277.152 26.74 277.629 26.3436 278.199 26.167C278.77 25.9904 279.386 26.048 279.914 26.3271L299.602 36.7656C300.13 37.046 300.525 37.5248 300.701 38.097C300.877 38.6693 300.819 39.2882 300.541 39.818L286.768 65.9792C286.489 66.5084 286.011 66.9048 285.441 67.0814C284.871 67.258 284.254 67.2004 283.726 66.9213L264.038 56.4828C263.511 56.2024 263.116 55.7236 262.94 55.1514C262.764 54.5791 262.821 53.9602 263.1 53.4304Z"
                                                    fill="#E6E6E6"/>
                                                <path
                                                    d="M268.769 46.33C269.013 41.0497 272.85 35.3368 277.624 29.5112C277.886 29.0156 278.332 28.6443 278.866 28.4789C279.4 28.3136 279.978 28.3675 280.473 28.6289L297.393 37.6C297.887 37.8625 298.257 38.311 298.421 38.8469C298.586 39.3828 298.532 39.9624 298.272 40.4587L286.016 63.7386C285.754 64.2342 285.307 64.6054 284.773 64.7708C284.239 64.9362 283.661 64.8822 283.167 64.6208L272.685 59.0634C270.486 57.8939 268.838 55.8965 268.104 53.5093C267.369 51.1221 267.609 48.5402 268.769 46.33Z"
                                                    fill="white"/>
                                                <path
                                                    d="M288.638 49.6995L275.425 42.7412C275.216 42.6299 275.059 42.44 274.989 42.2129C274.919 41.9859 274.942 41.7403 275.052 41.5298C275.162 41.3194 275.35 41.1612 275.576 41.0901C275.802 41.0189 276.047 41.0405 276.257 41.1501L289.47 48.1084C289.679 48.2197 289.836 48.4096 289.906 48.6367C289.976 48.8637 289.954 49.1094 289.844 49.3198C289.734 49.5303 289.545 49.6884 289.319 49.7596C289.093 49.8307 288.848 49.8091 288.638 49.6995Z"
                                                    fill="#DD4C27" class="none-real-price-svg-fill"/>
                                                <path
                                                    d="M280.614 39.9081L277.707 38.3773C277.602 38.3227 277.51 38.248 277.434 38.1574C277.358 38.0667 277.301 37.962 277.266 37.8491C277.23 37.7363 277.218 37.6175 277.228 37.4997C277.239 37.3819 277.272 37.2673 277.327 37.1626C277.382 37.0579 277.457 36.965 277.547 36.8894C277.638 36.8137 277.743 36.7568 277.855 36.7218C277.968 36.6868 278.086 36.6745 278.203 36.6856C278.321 36.6966 278.435 36.7308 278.539 36.7862L281.446 38.317C281.655 38.4283 281.812 38.6182 281.882 38.8453C281.952 39.0723 281.929 39.318 281.819 39.5284C281.709 39.7389 281.521 39.897 281.295 39.9682C281.069 40.0393 280.824 40.0178 280.614 39.9081Z"
                                                    fill="#DD4C27" class="none-real-price-svg-fill"/>
                                                <path
                                                    d="M284.981 56.6941L271.768 49.7357C271.558 49.6246 271.401 49.4346 271.331 49.2075C271.261 48.9803 271.283 48.7345 271.394 48.5239C271.504 48.3134 271.692 48.1552 271.919 48.0841C272.145 48.013 272.39 48.0347 272.6 48.1446L285.813 55.103C286.022 55.2142 286.179 55.4042 286.249 55.6312C286.319 55.8583 286.296 56.1039 286.186 56.3143C286.076 56.5248 285.887 56.6829 285.661 56.7541C285.436 56.8252 285.191 56.8037 284.981 56.6941Z"
                                                    fill="#DD4C27" class="none-real-price-svg-fill"/>
                                                <path
                                                    d="M286.81 53.197L273.598 46.2386C273.493 46.1841 273.4 46.1093 273.325 46.0187C273.249 45.9281 273.192 45.8233 273.156 45.7105C273.121 45.5976 273.108 45.4789 273.119 45.3611C273.129 45.2432 273.163 45.1287 273.218 45.0239C273.273 44.9192 273.347 44.8263 273.438 44.7507C273.529 44.6751 273.633 44.6181 273.746 44.5831C273.858 44.5482 273.977 44.5358 274.094 44.5469C274.212 44.5579 274.326 44.5921 274.43 44.6475L287.642 51.6059C287.852 51.7171 288.008 51.9071 288.078 52.1341C288.148 52.3612 288.126 52.6068 288.016 52.8173C287.906 53.0277 287.717 53.1858 287.491 53.257C287.265 53.3282 287.02 53.3066 286.81 53.197Z"
                                                    fill="#DD4C27" class="none-real-price-svg-fill"/>
                                                <path
                                                    d="M405.469 230.963H398.635C398.311 230.963 397.991 231.027 397.693 231.151C397.394 231.275 397.123 231.457 396.894 231.687C396.666 231.916 396.485 232.188 396.361 232.488C396.237 232.787 396.174 233.109 396.174 233.433C396.174 234.088 395.914 234.716 395.453 235.179C394.991 235.642 394.365 235.903 393.713 235.903H370.928C370.605 235.903 370.285 235.839 369.986 235.715C369.688 235.59 369.417 235.409 369.188 235.179C368.959 234.95 368.778 234.678 368.655 234.378C368.531 234.078 368.467 233.757 368.467 233.433L368.017 230.929L368.046 230.963L368.017 230.929L363.887 225.645C363.751 225.47 363.577 225.328 363.378 225.231C363.179 225.133 362.96 225.084 362.739 225.086H354.994C354.607 225.086 354.236 225.241 353.963 225.515C353.689 225.79 353.535 226.162 353.535 226.55L353.375 230.929H350.447C349.832 230.929 349.223 231.051 348.655 231.287C348.086 231.523 347.57 231.87 347.135 232.306C346.7 232.742 346.356 233.26 346.12 233.831C345.885 234.401 345.764 235.012 345.764 235.629V266.239C345.764 266.786 345.871 267.329 346.08 267.835C346.289 268.341 346.595 268.8 346.981 269.188C347.367 269.575 347.825 269.882 348.329 270.092C348.833 270.301 349.374 270.409 349.92 270.409H405.469C406.571 270.408 407.627 269.968 408.406 269.186C409.185 268.404 409.623 267.344 409.624 266.239V235.133C409.624 234.585 409.516 234.043 409.307 233.537C409.099 233.031 408.793 232.572 408.407 232.185C408.021 231.797 407.563 231.49 407.059 231.281C406.555 231.071 406.014 230.963 405.469 230.963Z"
                                                    fill="#F2F2F2"/>
                                                <path
                                                    d="M368.017 230.818H353.533V226.438C353.534 226.05 353.688 225.678 353.961 225.404C354.234 225.129 354.605 224.975 354.992 224.975H362.737C362.959 224.973 363.177 225.022 363.376 225.119C363.576 225.216 363.75 225.358 363.885 225.534L368.017 230.818Z"
                                                    fill="#E6E6E6"/>
                                                <path
                                                    d="M375.433 267.042H351.249C350.483 267.041 349.749 266.736 349.208 266.193C348.667 265.649 348.362 264.913 348.361 264.144V257.507C348.362 256.739 348.667 256.002 349.208 255.459C349.749 254.916 350.483 254.61 351.249 254.609H380.276C381.041 254.61 381.775 254.916 382.317 255.459C382.858 256.002 383.162 256.739 383.163 257.507V259.285C383.161 261.341 382.346 263.313 380.897 264.768C379.448 266.222 377.483 267.04 375.433 267.042Z"
                                                    fill="white"/>
                                                <path
                                                    d="M358.211 259.616H352.241C351.853 259.616 351.481 259.462 351.206 259.186C350.932 258.91 350.777 258.537 350.777 258.147C350.777 257.757 350.932 257.384 351.206 257.108C351.481 256.833 351.853 256.678 352.241 256.678H358.211C358.599 256.678 358.972 256.833 359.246 257.108C359.521 257.384 359.675 257.757 359.675 258.147C359.675 258.537 359.521 258.91 359.246 259.186C358.972 259.462 358.599 259.616 358.211 259.616Z"
                                                    fill="#F2F2F2"/>
                                                <path
                                                    d="M378.485 264.249H352.243C352.05 264.25 351.859 264.212 351.681 264.138C351.503 264.065 351.342 263.956 351.205 263.82C351.069 263.683 350.961 263.521 350.887 263.343C350.813 263.164 350.775 262.973 350.775 262.78C350.775 262.587 350.813 262.395 350.887 262.217C350.961 262.038 351.069 261.876 351.205 261.74C351.342 261.603 351.503 261.495 351.681 261.422C351.859 261.348 352.05 261.31 352.243 261.311H378.485C378.873 261.311 379.246 261.465 379.52 261.741C379.795 262.016 379.949 262.39 379.949 262.78C379.949 263.17 379.795 263.543 379.52 263.819C379.246 264.094 378.873 264.249 378.485 264.249H378.485Z"
                                                    fill="#F2F2F2"/>
                                                <path
                                                    d="M429.746 264.547H422.912C422.589 264.547 422.269 264.611 421.97 264.735C421.672 264.859 421.4 265.041 421.172 265.271C420.943 265.5 420.762 265.772 420.638 266.072C420.515 266.371 420.451 266.693 420.451 267.017C420.451 267.672 420.192 268.3 419.73 268.763C419.269 269.226 418.643 269.487 417.99 269.487H395.205C394.882 269.487 394.562 269.423 394.264 269.299C393.965 269.174 393.694 268.993 393.465 268.763C393.237 268.534 393.056 268.262 392.932 267.962C392.808 267.662 392.745 267.341 392.745 267.017L392.294 264.513L392.323 264.547L392.294 264.513L388.164 259.229C388.029 259.054 387.855 258.912 387.656 258.815C387.456 258.717 387.238 258.668 387.016 258.67H379.271C378.884 258.67 378.513 258.825 378.24 259.099C377.967 259.374 377.813 259.746 377.812 260.134L377.652 264.513H374.724C374.109 264.513 373.5 264.635 372.932 264.871C372.364 265.107 371.848 265.454 371.413 265.89C370.978 266.326 370.633 266.844 370.398 267.415C370.162 267.985 370.041 268.596 370.041 269.213V299.823C370.041 300.37 370.149 300.913 370.357 301.419C370.566 301.925 370.872 302.384 371.258 302.772C371.644 303.159 372.102 303.466 372.607 303.676C373.111 303.885 373.651 303.993 374.197 303.993H429.746C430.848 303.992 431.904 303.552 432.683 302.77C433.462 301.988 433.9 300.928 433.901 299.823V268.717C433.901 268.169 433.794 267.627 433.585 267.121C433.376 266.615 433.07 266.156 432.684 265.769C432.298 265.381 431.84 265.074 431.336 264.865C430.832 264.655 430.292 264.547 429.746 264.547Z"
                                                    fill="#F2F2F2"/>
                                                <path
                                                    d="M392.296 264.4H377.812V260.02C377.813 259.632 377.967 259.26 378.24 258.986C378.514 258.712 378.884 258.557 379.271 258.557H387.016C387.238 258.555 387.457 258.604 387.656 258.701C387.855 258.798 388.029 258.94 388.164 259.116L392.296 264.4Z"
                                                    fill="#E6E6E6"/>
                                                <path
                                                    d="M399.713 300.626H375.528C374.763 300.625 374.029 300.32 373.487 299.777C372.946 299.233 372.641 298.497 372.641 297.728V291.091C372.641 290.323 372.946 289.586 373.487 289.043C374.029 288.5 374.763 288.194 375.528 288.193H404.555C405.321 288.194 406.055 288.5 406.596 289.043C407.137 289.586 407.442 290.323 407.443 291.091V292.869C407.44 294.925 406.625 296.897 405.176 298.352C403.727 299.806 401.762 300.624 399.713 300.626Z"
                                                    fill="white"/>
                                                <path
                                                    d="M382.49 293.198H376.521C376.132 293.198 375.76 293.044 375.485 292.768C375.211 292.493 375.057 292.119 375.057 291.729C375.057 291.339 375.211 290.966 375.485 290.69C375.76 290.415 376.132 290.26 376.521 290.26H382.49C382.878 290.26 383.251 290.415 383.525 290.69C383.8 290.966 383.954 291.339 383.954 291.729C383.954 292.119 383.8 292.493 383.525 292.768C383.251 293.044 382.878 293.198 382.49 293.198Z"
                                                    fill="#F2F2F2"/>
                                                <path
                                                    d="M402.762 297.833H376.52C376.327 297.834 376.137 297.796 375.959 297.722C375.781 297.649 375.619 297.54 375.483 297.404C375.346 297.267 375.238 297.105 375.164 296.927C375.091 296.748 375.053 296.557 375.053 296.364C375.053 296.171 375.091 295.979 375.164 295.801C375.238 295.622 375.346 295.46 375.483 295.324C375.619 295.187 375.781 295.079 375.959 295.006C376.137 294.932 376.327 294.894 376.52 294.895H402.762C403.151 294.895 403.523 295.049 403.798 295.325C404.072 295.6 404.226 295.974 404.226 296.364C404.226 296.754 404.072 297.127 403.798 297.403C403.523 297.678 403.151 297.833 402.762 297.833H402.762Z"
                                                    fill="#F2F2F2"/>
                                                <path d="M321.179 292.469L315.536 292.468L312.852 270.625H321.18L321.179 292.469Z" fill="#FFB6B6"/>
                                                <path
                                                    d="M304.147 300.824C304.15 301.458 304.402 302.066 304.849 302.515C305.295 302.964 305.9 303.218 306.532 303.222H317.156L317.485 302.537L318.987 299.426L319.569 302.537L319.698 303.222H323.705L323.648 302.533L322.579 289.675L321.182 289.589L315.143 289.23L313.659 289.139V292.978C312.533 294.179 303.699 298.722 304.147 300.824Z"
                                                    fill="#2F2E41"/>
                                                <path d="M414.612 248.729L411.885 253.687L391.531 245.489L395.557 238.172L414.612 248.729Z" fill="#FFB6B6"/>
                                                <path
                                                    d="M413.67 267.732C414.224 268.036 414.876 268.108 415.484 267.933C416.091 267.758 416.605 267.349 416.914 266.795L422.048 257.462L421.61 256.842L419.622 254.019L422.617 255.011L423.277 255.229L425.213 251.708L424.584 251.425L412.851 246.15L412.1 247.337L408.869 252.469L408.072 253.728L411.422 255.584C411.926 257.153 411.62 267.11 413.67 267.732Z"
                                                    fill="#2F2E41"/>
                                                <path
                                                    d="M330.621 148.502L351.943 157.588C351.943 157.588 358.765 172.203 354.048 174.297V212.936L402.751 241.222L388.071 265.829C388.071 265.829 369.228 260.945 369.425 256.486C369.622 252.027 371.794 250.263 365.324 249.69C358.855 249.118 355.19 249.596 355.366 245.616C355.542 241.637 332.516 220.947 332.516 220.947L330.621 148.502Z"
                                                    fill="#2F2E41"/>
                                                <path
                                                    d="M335.731 155.92L330.324 149.824C330.324 149.824 318.181 169.833 318.227 173.943C318.273 178.053 307.92 199.248 307.92 199.248L295.082 274.883C295.082 274.883 319.843 280.79 321.75 280.953C323.656 281.117 326.871 282.125 324.849 278.296C322.828 274.467 324.849 274.467 324.849 274.467L326.092 216.234L335.731 176.182V155.92Z"
                                                    fill="#2F2E41"/>
                                                <path
                                                    d="M332.894 97.3275L343.247 94.834L349.234 102.203C351.966 104.783 354.004 108.015 355.156 111.597C356.308 115.18 356.538 118.998 355.824 122.693L350.287 151.353C350.287 151.353 360.226 160.495 358.984 165.482C356.969 173.571 334.746 166.428 330.922 166.994C327.097 167.56 322.127 161.349 321.299 157.806C320.471 154.262 323.849 145.756 325.026 145.95C326.203 146.144 321.778 128.355 321.778 128.355C321.778 128.355 322.127 116.444 326.269 113.119C328.808 111.044 330.875 108.446 332.33 105.502L332.894 97.3275Z"
                                                    fill="#DD4C27" class="none-real-price-svg-fill"/>
                                                <path
                                                    d="M287.946 52.3944C287.954 53.0931 288.113 53.7817 288.412 54.4125C288.711 55.0434 289.143 55.6015 289.679 56.0483C290.214 56.495 290.84 56.8197 291.512 57C292.185 57.1802 292.889 57.2117 293.575 57.0922L306.607 77.27L313.054 75.0248L297.402 51.1729C297.115 50.0291 296.421 49.0304 295.45 48.3662C294.479 47.7019 293.299 47.4182 292.133 47.5687C290.967 47.7193 289.897 48.2937 289.126 49.1831C288.354 50.0725 287.934 51.2151 287.946 52.3944H287.946Z"
                                                    fill="#FFB6B6"/>
                                                <path
                                                    d="M340.206 122.737C340.206 122.737 345.113 112.192 341.381 107.505C337.648 102.818 334.92 98.0536 332.831 96.7631C330.742 95.4725 322.417 80.5285 320.318 80.0822C318.22 79.636 319.85 77.2133 316.92 75.9131C313.99 74.6128 313.149 74.6032 313.159 73.7589C313.168 72.9147 306.014 62.7773 306.014 62.7773L298.66 67.3583L316.625 104.238L340.206 122.737Z"
                                                    fill="#DD4C27" class="none-real-price-svg-fill"/>
                                                <path
                                                    d="M293.843 221.417C284.435 208.86 278.997 194.817 278.819 178.807C278.516 177.944 278.566 176.996 278.959 176.17C279.351 175.345 280.054 174.709 280.913 174.403L312.981 163.017C313.84 162.713 314.785 162.763 315.608 163.157C316.431 163.551 317.064 164.257 317.369 165.119L332.393 207.729C332.696 208.592 332.645 209.54 332.253 210.366C331.86 211.191 331.157 211.827 330.298 212.133L298.231 223.519C297.371 223.824 296.426 223.773 295.604 223.379C294.781 222.985 294.148 222.28 293.843 221.417Z"
                                                    fill="#E6E6E6"/>
                                                <path
                                                    d="M291.764 207.673C286.106 201.932 283.684 191.692 282.105 180.28C281.821 179.472 281.869 178.584 282.236 177.81C282.604 177.037 283.262 176.442 284.067 176.155L311.626 166.37C312.431 166.085 313.316 166.132 314.087 166.501C314.857 166.87 315.45 167.531 315.736 168.338L329.105 206.256C329.389 207.064 329.342 207.952 328.974 208.725C328.606 209.498 327.948 210.093 327.143 210.38L310.071 216.442C306.484 217.711 302.543 217.5 299.111 215.857C295.679 214.213 293.036 211.27 291.764 207.673Z"
                                                    fill="white"/>
                                                <path
                                                    d="M316.106 188.765L294.638 196.455C294.296 196.577 293.92 196.558 293.593 196.402C293.265 196.246 293.012 195.966 292.89 195.623C292.768 195.281 292.787 194.903 292.942 194.574C293.098 194.245 293.377 193.992 293.718 193.869L315.186 186.179C315.355 186.119 315.535 186.092 315.714 186.101C315.893 186.11 316.069 186.155 316.232 186.232C316.394 186.309 316.539 186.418 316.66 186.551C316.78 186.685 316.874 186.841 316.934 187.011C316.994 187.18 317.021 187.36 317.012 187.54C317.003 187.72 316.959 187.897 316.882 188.06C316.805 188.223 316.697 188.369 316.564 188.49C316.43 188.611 316.275 188.704 316.106 188.765Z"
                                                    fill="#DD4C27" class="none-real-price-svg-fill"/>
                                                <path
                                                    d="M296.839 187.674L292.116 189.366C291.774 189.487 291.399 189.468 291.072 189.312C290.745 189.156 290.492 188.876 290.371 188.533C290.249 188.191 290.267 187.814 290.422 187.486C290.577 187.157 290.855 186.903 291.196 186.78L295.919 185.089C296.26 184.967 296.636 184.987 296.963 185.143C297.29 185.299 297.542 185.579 297.664 185.921C297.786 186.263 297.767 186.64 297.613 186.969C297.458 187.297 297.18 187.551 296.839 187.674Z"
                                                    fill="#DD4C27" class="none-real-price-svg-fill"/>
                                                <path
                                                    d="M320.147 200.13L298.679 207.82C298.51 207.88 298.33 207.907 298.151 207.898C297.972 207.889 297.796 207.845 297.634 207.768C297.471 207.69 297.326 207.582 297.205 207.448C297.085 207.315 296.992 207.158 296.931 206.989C296.871 206.819 296.844 206.639 296.853 206.459C296.862 206.279 296.906 206.102 296.983 205.94C297.06 205.777 297.168 205.631 297.302 205.51C297.435 205.389 297.59 205.295 297.759 205.235L319.227 197.545C319.396 197.484 319.576 197.458 319.755 197.467C319.934 197.476 320.11 197.52 320.273 197.597C320.435 197.674 320.58 197.783 320.701 197.916C320.821 198.05 320.915 198.206 320.975 198.376C321.035 198.546 321.062 198.726 321.053 198.906C321.044 199.086 321 199.262 320.923 199.425C320.846 199.588 320.738 199.734 320.605 199.855C320.471 199.976 320.316 200.069 320.147 200.13Z"
                                                    fill="#DD4C27" class="none-real-price-svg-fill"/>
                                                <path
                                                    d="M318.125 194.448L296.657 202.138C296.488 202.199 296.309 202.225 296.13 202.216C295.95 202.207 295.774 202.163 295.612 202.086C295.45 202.009 295.304 201.9 295.184 201.767C295.063 201.633 294.97 201.477 294.91 201.307C294.849 201.137 294.823 200.957 294.832 200.777C294.841 200.597 294.885 200.421 294.962 200.258C295.039 200.095 295.147 199.949 295.28 199.828C295.413 199.707 295.569 199.614 295.738 199.553L317.206 191.863C317.547 191.741 317.923 191.76 318.251 191.915C318.579 192.071 318.832 192.351 318.953 192.694C319.075 193.037 319.057 193.414 318.901 193.743C318.746 194.072 318.467 194.326 318.125 194.448Z"
                                                    fill="#DD4C27" class="none-real-price-svg-fill"/>
                                                <path
                                                    d="M334.15 93.5707C340.289 93.5707 345.266 88.5767 345.266 82.4162C345.266 76.2558 340.289 71.2617 334.15 71.2617C328.012 71.2617 323.035 76.2558 323.035 82.4162C323.035 88.5767 328.012 93.5707 334.15 93.5707Z"
                                                    fill="#FFB6B6"/>
                                                <path
                                                    d="M322.462 80.9603C323.052 81.3551 323.756 81.5436 324.464 81.4968C324.627 80.643 324.653 79.7685 324.541 78.9064C324.962 79.6801 325.279 80.5065 325.484 81.364C327.46 80.9309 327.373 80.3409 329.409 80.6496C329.969 80.768 330.498 81.0006 330.964 81.3331C331.43 81.6655 331.823 82.0906 332.118 82.582C332.413 83.0734 332.605 83.6204 332.68 84.1892C332.756 84.758 332.714 85.3362 332.557 85.888C332.989 84.94 334.781 85.3709 335.083 86.4558C335.399 87.5975 334.705 88.7515 334.04 89.7314C331.668 93.234 337.803 99.6902 335.431 103.193L335.101 103.589C337.175 102.506 339.137 101.22 340.959 99.7491C340.647 98.3655 340.593 96.936 340.799 95.5327C341.057 96.6887 341.687 97.727 342.593 98.4865C349.305 93.2053 357.378 85.6024 355.893 83.7573L351.376 75.7659C346.628 67.3712 335.177 63.9989 328.083 70.5173C327.897 70.6911 327.477 70.5759 327.29 70.7589C325.252 71.2889 322.643 72.2491 321.311 73.8841C319.985 75.5218 320.72 79.78 322.462 80.9603Z"
                                                    fill="#2F2E41"/>
                                                <path
                                                    d="M331.158 167.342C322.115 162.503 315.018 155.681 310.499 146.232C310.082 145.804 309.85 145.228 309.856 144.629C309.861 144.03 310.103 143.458 310.528 143.038L326.415 127.381C326.841 126.961 327.415 126.729 328.012 126.734C328.609 126.74 329.179 126.983 329.598 127.409L350.257 148.519C350.675 148.947 350.906 149.524 350.901 150.123C350.895 150.721 350.653 151.294 350.228 151.714L334.342 167.371C333.915 167.79 333.341 168.023 332.744 168.017C332.147 168.012 331.577 167.769 331.158 167.342Z"
                                                    fill="#E6E6E6"/>
                                                <path
                                                    d="M326.137 159.765C321.197 157.93 316.937 152.527 312.855 146.194C312.464 145.793 312.247 145.253 312.252 144.692C312.257 144.131 312.484 143.595 312.882 143.202L326.535 129.746C326.934 129.353 327.472 129.136 328.031 129.141C328.59 129.146 329.124 129.373 329.516 129.773L347.9 148.558C348.291 148.958 348.508 149.498 348.503 150.059C348.498 150.62 348.271 151.156 347.873 151.549L339.415 159.885C337.637 161.634 335.24 162.603 332.751 162.581C330.262 162.558 327.883 161.545 326.137 159.765Z"
                                                    fill="white"/>
                                                <path
                                                    d="M335.366 141.788L324.749 152.31C324.666 152.393 324.567 152.458 324.458 152.503C324.349 152.548 324.232 152.57 324.115 152.569C323.997 152.569 323.881 152.545 323.772 152.499C323.664 152.453 323.566 152.386 323.483 152.302C323.4 152.218 323.335 152.119 323.291 152.009C323.246 151.9 323.224 151.783 323.225 151.665C323.225 151.547 323.249 151.43 323.295 151.322C323.341 151.213 323.407 151.114 323.491 151.031L334.108 140.509C334.192 140.427 334.291 140.361 334.4 140.316C334.509 140.272 334.625 140.249 334.743 140.25C334.86 140.251 334.977 140.275 335.085 140.321C335.194 140.366 335.292 140.433 335.374 140.517C335.457 140.601 335.522 140.701 335.567 140.81C335.611 140.919 335.633 141.036 335.633 141.154C335.632 141.272 335.608 141.389 335.562 141.498C335.517 141.606 335.45 141.705 335.366 141.788Z"
                                                    fill="#DD4C27" class="none-real-price-svg-fill"/>
                                                <path
                                                    d="M323.636 146.49L321.3 148.805C321.131 148.973 320.903 149.066 320.665 149.064C320.428 149.063 320.201 148.967 320.034 148.797C319.867 148.628 319.774 148.399 319.775 148.16C319.777 147.922 319.873 147.694 320.042 147.527L322.377 145.212C322.461 145.129 322.56 145.063 322.669 145.018C322.778 144.973 322.895 144.951 323.012 144.951C323.13 144.952 323.247 144.976 323.355 145.022C323.464 145.067 323.562 145.134 323.645 145.218C323.728 145.302 323.793 145.402 323.837 145.511C323.882 145.621 323.904 145.738 323.903 145.856C323.902 145.974 323.878 146.091 323.832 146.2C323.786 146.309 323.719 146.408 323.636 146.49Z"
                                                    fill="#DD4C27" class="none-real-price-svg-fill"/>
                                                <path
                                                    d="M340.897 147.409L330.281 157.931C330.197 158.014 330.098 158.08 329.989 158.124C329.88 158.169 329.763 158.191 329.646 158.19C329.528 158.19 329.412 158.166 329.303 158.12C329.195 158.074 329.097 158.007 329.014 157.923C328.931 157.839 328.866 157.74 328.822 157.631C328.778 157.521 328.755 157.404 328.756 157.286C328.757 157.168 328.781 157.051 328.826 156.943C328.872 156.834 328.939 156.735 329.022 156.652L339.639 146.131C339.723 146.048 339.822 145.982 339.931 145.937C340.04 145.893 340.156 145.87 340.274 145.871C340.392 145.872 340.508 145.896 340.616 145.942C340.725 145.987 340.823 146.054 340.906 146.138C340.988 146.222 341.054 146.322 341.098 146.431C341.142 146.54 341.165 146.657 341.164 146.775C341.163 146.893 341.139 147.01 341.094 147.119C341.048 147.228 340.981 147.326 340.897 147.409Z"
                                                    fill="#DD4C27" class="none-real-price-svg-fill"/>
                                                <path
                                                    d="M338.131 144.598L327.514 155.12C327.431 155.203 327.331 155.269 327.222 155.314C327.113 155.358 326.997 155.381 326.879 155.381C326.761 155.38 326.645 155.356 326.536 155.31C326.428 155.264 326.329 155.198 326.247 155.113C326.164 155.029 326.098 154.93 326.054 154.82C326.01 154.711 325.987 154.594 325.988 154.475C325.989 154.357 326.013 154.24 326.059 154.132C326.105 154.023 326.172 153.924 326.256 153.841L336.873 143.319C337.042 143.152 337.27 143.059 337.508 143.061C337.745 143.062 337.972 143.158 338.139 143.328C338.306 143.497 338.398 143.726 338.397 143.964C338.396 144.203 338.3 144.431 338.131 144.598V144.598Z"
                                                    fill="#DD4C27" class="none-real-price-svg-fill"/>
                                                <path
                                                    d="M315.372 189.206C315.24 188.52 315.259 187.813 315.426 187.135C315.593 186.456 315.905 185.823 316.34 185.277C316.775 184.732 317.323 184.288 317.946 183.976C318.569 183.664 319.252 183.492 319.948 183.471L328.683 161.08L335.449 161.982L324.88 188.499C324.828 189.678 324.347 190.796 323.529 191.642C322.71 192.488 321.611 193.004 320.439 193.091C319.267 193.178 318.104 192.83 317.17 192.114C316.236 191.398 315.596 190.363 315.372 189.206Z"
                                                    fill="#FFB6B6"/>
                                                <path
                                                    d="M352.513 109.775C352.513 109.775 359.428 119.119 356.708 124.461C353.987 129.804 352.266 135.021 350.478 136.706C348.69 138.39 343.519 154.706 341.552 155.566C339.586 156.425 341.667 158.471 339.057 160.334C336.446 162.197 335.624 162.376 335.802 163.201C335.98 164.026 330.997 175.398 330.997 175.398L322.877 172.39L340.168 112.033L352.513 109.775Z"
                                                    fill="#DD4C27" class="none-real-price-svg-fill"/>
                                                <path
                                                    d="M482.219 304.001L47.3357 303.545C47.1289 303.544 46.9307 303.461 46.7847 303.314C46.6387 303.167 46.5566 302.968 46.5566 302.761C46.5566 302.553 46.6387 302.354 46.7847 302.207C46.9307 302.06 47.1289 301.977 47.3357 301.977L482.219 302.433C482.322 302.432 482.424 302.452 482.519 302.492C482.614 302.531 482.7 302.589 482.773 302.662C482.846 302.734 482.904 302.821 482.943 302.916C482.982 303.011 483.003 303.114 483.003 303.217C483.003 303.32 482.982 303.422 482.943 303.517C482.904 303.613 482.846 303.699 482.773 303.772C482.7 303.845 482.614 303.903 482.519 303.942C482.424 303.981 482.322 304.001 482.219 304.001Z"
                                                    fill="#CACACA"/>
                                                <path
                                                    d="M163.379 131.292C158.229 122.4 155.774 112.85 156.89 102.429C156.759 101.845 156.865 101.232 157.184 100.726C157.502 100.22 158.008 99.8609 158.59 99.7285L180.311 94.8107C180.893 94.6796 181.504 94.7856 182.008 95.1055C182.513 95.4254 182.87 95.933 183.002 96.5171L189.491 125.38C189.622 125.964 189.516 126.576 189.197 127.083C188.878 127.589 188.373 127.948 187.791 128.08L166.07 132.998C165.487 133.129 164.877 133.023 164.372 132.703C163.868 132.383 163.511 131.876 163.379 131.292Z"
                                                    fill="#E6E6E6"/>
                                                <path
                                                    d="M163.084 122.196C159.848 118.026 159.061 111.182 158.913 103.641C158.79 103.094 158.889 102.52 159.188 102.046C159.486 101.572 159.96 101.236 160.505 101.112L179.172 96.8854C179.718 96.7626 180.289 96.8618 180.762 97.1614C181.234 97.461 181.569 97.9364 181.693 98.4834L187.467 124.167C187.589 124.714 187.49 125.288 187.192 125.762C186.893 126.236 186.419 126.572 185.874 126.696L174.31 129.315C171.881 129.862 169.335 129.419 167.23 128.085C165.126 126.751 163.635 124.633 163.084 122.196Z"
                                                    fill="white"/>
                                                <path
                                                    d="M170.346 108.021C170.726 107.58 171.238 107.275 171.806 107.151C172.373 107.027 172.965 107.09 173.493 107.332C174.022 107.614 174.445 108.06 174.699 108.603C174.953 109.147 175.024 109.758 174.902 110.346C174.697 111.704 173.99 112.941 173.926 114.332C173.868 114.941 173.974 115.555 174.233 116.109C174.491 116.663 174.893 117.138 175.397 117.484C176.167 117.954 176.961 116.79 176.186 116.318C174.912 115.541 175.34 113.833 175.71 112.669C176.171 111.214 176.652 109.732 176.081 108.233C175.829 107.606 175.423 107.052 174.902 106.623C174.381 106.193 173.761 105.902 173.098 105.775C172.436 105.648 171.752 105.69 171.11 105.897C170.468 106.103 169.888 106.468 169.423 106.958C168.814 107.616 169.73 108.687 170.346 108.021Z"
                                                    fill="#DD4C27" class="none-real-price-svg-fill"/>
                                                <path
                                                    d="M176.531 121.546C177.307 121.546 177.936 120.914 177.936 120.136C177.936 119.358 177.307 118.727 176.531 118.727C175.756 118.727 175.127 119.358 175.127 120.136C175.127 120.914 175.756 121.546 176.531 121.546Z"
                                                    fill="#DD4C27" class="none-real-price-svg-fill"/>
                                                <path
                                                    d="M39.2243 69.9049C34.0746 61.0129 31.62 51.4633 32.7356 41.0422C32.6049 40.4579 32.7106 39.8454 33.0293 39.3392C33.3481 38.8329 33.8539 38.4742 34.4359 38.3417L56.1569 33.424C56.7392 33.2929 57.3495 33.3989 57.854 33.7188C58.3584 34.0387 58.7159 34.5463 58.8479 35.1303L65.3366 63.993C65.4672 64.5773 65.3616 65.1898 65.0429 65.6961C64.7241 66.2023 64.2183 66.561 63.6363 66.6935L41.9153 71.6112C41.333 71.7424 40.7227 71.6363 40.2182 71.3165C39.7137 70.9966 39.3562 70.4889 39.2243 69.9049Z"
                                                    fill="#E6E6E6"/>
                                                <path
                                                    d="M38.9298 60.8097C35.6932 56.6393 34.9064 49.7953 34.7583 42.2542C34.6359 41.7069 34.7348 41.1333 35.0333 40.6592C35.3318 40.185 35.8056 39.8491 36.3506 39.725L55.018 35.4987C55.5633 35.3759 56.135 35.4751 56.6074 35.7747C57.0799 36.0743 57.4147 36.5497 57.5383 37.0967L63.3124 62.7805C63.4348 63.3277 63.3358 63.9014 63.0373 64.3755C62.7387 64.8497 62.2649 65.1856 61.7199 65.3096L50.1558 67.9278C47.7268 68.4748 45.1807 68.0327 43.0761 66.6982C40.9716 65.3638 39.4804 63.2461 38.9298 60.8097Z"
                                                    fill="white"/>
                                                <path
                                                    d="M48.6873 62.7674C49.7745 62.7674 50.6558 61.8829 50.6558 60.7919C50.6558 59.7009 49.7745 58.8164 48.6873 58.8164C47.6001 58.8164 46.7188 59.7009 46.7188 60.7919C46.7188 61.8829 47.6001 62.7674 48.6873 62.7674Z"
                                                    fill="#DD4C27" class="none-real-price-svg-fill"/>
                                                <path
                                                    d="M51.0389 42.0312C50.2812 41.1397 48.8949 41.2814 47.7479 41.5007C46.5562 41.6745 45.3929 42.0069 44.2887 42.4891C43.7372 42.7333 43.2395 43.0846 42.824 43.5228C42.4086 43.9611 42.0837 44.4775 41.8682 45.0424C41.41 46.4523 41.9089 47.9845 42.5074 49.3404C43.6595 51.9485 45.1889 54.3717 47.046 56.5317L47.9844 56.9679C49.4443 55.1015 50.5173 52.9608 51.1403 50.672C51.7632 48.3831 51.9236 45.9923 51.6118 43.6404C51.5762 43.0604 51.3775 42.5025 51.0389 42.0312Z"
                                                    fill="#DD4C27" class="none-real-price-svg-fill"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_3038_44050">
                                                    <rect width="483" height="304" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>

                                        <!--                                        <img src="@/assets/images/none_real_price.svg" class="w-100">-->
                                    </div>
                                    <div class="col-6">
                                        <div class="none-real-price">尚未有實價登錄資料</div>
                                    </div>
                                </div>
                            </div>
                            <div class="actual-table-wrapper" v-if="community.realPriceTotal > 0">
                                <div class="d-flex mb-3">
                                    <p class="tt2 mb-0">
                                        共有 <span class="text-danger">{{ community.realPriceTotal }}</span> 筆實價登錄
                                        <i class="icon ms-1 text-primary" data-toggle="tooltip" data-bs-html="true" data-bs-placement="bottom"
                                           title="・公寓 - 5樓含以下無電梯<br>・華廈 - 10樓含以下有電梯<br>・住宅大樓 - 11樓含以上有電梯">
                                            <IconInfo/>
                                        </i>
                                    </p>
                                    <div class="icon ms-auto d-block d-lg-none">
                                        <IconSort/>
                                    </div>
                                </div>
                                <div class="d-none d-lg-block">
                                    <table class="actual-table table">
                                        <thead>
                                        <tr>
                                            <th class="text-center">年月 <i class="icon" @click="realPriceSort('transactionDate')">
                                                <IconSort/>
                                            </i></th>
                                            <th class="text-center">地址</th>
                                            <th class="text-center">型態</th>
                                            <th class="text-center">總價 <i class="icon" @click="realPriceSort('totalPrice')">
                                                <IconSort/>
                                            </i></th>
                                            <th class="text-center">單價 <i class="icon" @click="realPriceSort('averagePrice')">
                                                <IconSort/>
                                            </i></th>
                                            <th class="text-center">總坪 <i class="icon" @click="realPriceSort('totalPing')">
                                                <IconSort/>
                                            </i></th>
                                            <th class="text-center">地坪 <i class="icon" @click="realPriceSort('landPing')">
                                                <IconSort/>
                                            </i></th>
                                            <th class="text-center">屋齡 <i class="icon" @click="realPriceSort('age')">
                                                <IconSort/>
                                            </i></th>
                                            <th class="text-center">樓層</th>
                                            <th class="text-center">格局 <i class="icon" @click="realPriceSort('pattern')">
                                                <IconSort/>
                                            </i></th>
                                            <th class="text-center"></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="house in community.realPriceList">
                                            <td>{{ house.transactionDate }}</td>
                                            <td>
                                                <div class="address-group">
                                                    <img src="../assets/images/group-3337.png" alt="" class="group-3337">
                                                    <div class="text-start">
                                                        <div>{{ house.address }}</div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td v-html="house.webType"></td>
                                            <td><b class="text-danger">{{ house.totalPrice }}萬</b></td>
                                            <td>{{ house.averagePrice }}萬</td>
                                            <td>{{ house.totalPing }}坪</td>
                                            <td>{{ house.landPing == 0 ? '--' : house.landPing + '坪' }}</td>
                                            <td>{{ house.age }}年</td>
                                            <td>{{ house.floor }}</td>
                                            <td>{{ house.pattern }}</td>
                                            <td>
                                                <div class="tag-lbgreen">內政部</div>
                                                <div>
                                                    <a href="javascript:;" class="link-red_uii" data-bs-toggle="modal"
                                                       :data-bs-target="house.category == 2 ? '#actualModal2' : '#actualModal'"
                                                       @click="showModal(house)">完整資訊</a>
                                                </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="d-block d-lg-none">
                                    <div class="actual-tbcard" v-for="house in community.realPriceList">
                                        <h3 class="title"></h3>
                                        <div class="d-block d-md-flex align-items-start">
                                            <div class="info-container">
                                                <div class="infos-group">
                                                    <p class="infos">
                                                        <span class="me-3">{{ house.age }}年</span>
                                                        <span class="me-3">{{ house.floor }}</span>
                                                        <span class="">{{ house.type }}</span>
                                                    </p>
                                                    <p class="infos">
                                                        <span class="me-3">總坪 {{ house.totalPing }} 坪</span>
                                                        <span>建坪 {{ house.buildingPing }} 坪</span>
                                                    </p>
                                                    <p class="address">
                                                        <i class="icon me-2">
                                                            <IconPin class="stroke-primary"/>
                                                        </i> {{ house.address }}
                                                    </p>
                                                    <p class="address" v-if="house.communityName != ''">
                                                        <i class="icon me-1">
                                                            <IconBuilding class="stroke-primary fill-primary"/>
                                                        </i> {{ house.communityName }}
                                                    </p>
                                                </div>
                                                <div class="uii-gup d-flex justify-content-end justify-content-md-start align-items-center">
                                                    <a href="javascript:;" class="link-red_uii me-0 me-md-3 order-2 order-md-1" data-bs-toggle="modal"
                                                       :data-bs-target="house.category == 2 ? '#actualModal2' : '#actualModal'"
                                                       @click="showModal(house)">查看完整資訊</a>
                                                    <span class="tag-lbgreen me-2 md-md-0 order-1 order-md-2">內政部</span>
                                                </div>
                                            </div>
                                            <div class="price-group row gx-2">
                                                <div class="crd col-6">
                                                    <p class="prc mb-0"><span class="value">{{ house.totalPrice }}</span> <small>萬</small></p>
                                                    <div class="unit">總價</div>
                                                </div>
                                                <div class="crd col-6">
                                                    <p class="prc mb-0"><span class="value">{{ house.averagePrice }}</span> <small>萬/坪</small></p>
                                                    <div class="unit">單價</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <nav aria-label="Page navigation" v-html="community.realPricePaginate">
                                </nav>
                                <!--                                <nav aria-label="Page navigation">-->
                                <!--                                    <ul class="pagination mb-0">-->
                                <!--                                        <li class="page-item disabled"><a href="javascript:;" class="page-link disabled" aria-label="Previous"></a></li>-->
                                <!--                                        <li class="page-item active"><a href="javascript:;" class="page-link">1</a></li>-->
                                <!--                                        <li class="page-item "><a href="javascript:;" class="page-link">2</a></li>-->
                                <!--                                        <li class="page-item"><a href="javascript:;" class="page-link" aria-label="Next"></a></li>-->
                                <!--                                    </ul>-->
                                <!--                                </nav>-->
                                <div class="community-detail-pagination-border-bottom"></div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="actual-chart" v-if="community.isChart == 1">
                    <div class="container">
                        <div class="redline-heading d-flex justify-content-between align-items-center">
                            <h2>{{ community.title }}</h2>
                            <div class="rg-links d-none d-md-block">
                                <a href="javascript:;" :class="checkedRange == 3 ? 'active' : ''" @click="changeRange(3)">3個月內</a>
                                <a href="javascript:;" :class="checkedRange == 6 ? 'active' : ''" @click="changeRange(6)">半年內</a>
                                <a href="javascript:;" :class="checkedRange == 12 ? 'active' : ''" @click="changeRange(12)">一年內</a>
                            </div>
                        </div>
                        <div class="rg-links d-block d-md-none my-3 text-center">
                            <a href="javascript:;" :class="checkedRange == 3 ? 'active' : ''" @click="changeRange(3)">3個月內</a>
                            <a href="javascript:;" :class="checkedRange == 6 ? 'active' : ''" @click="changeRange(6)">半年內</a>
                            <a href="javascript:;" :class="checkedRange == 12 ? 'active' : ''" @click="changeRange(12)">一年內</a>
                        </div>
                        <div class="charts-top-status d-md-flex align-items-baseline justify-content-between mb-4 my-2 px-md-4">
                            <div class="date">{{ community.roomsStatistics.total[checkedRange].monthS }} ~
                                {{ community.roomsStatistics.total[checkedRange].monthE }}
                            </div>
                            <div class="info">
                                <div><span class="d-block d-md-inline-block">平均單價</span><b
                                    class="text-red mx-2">{{ community.roomsStatistics.total[checkedRange].average }}</b>萬/坪
                                </div>
                                <div class="ms-md-3"><span class="d-block d-md-inline-block">成交件數</span><b
                                    class="text-red mx-2">{{ community.roomsStatistics.total[checkedRange].count }}</b>件
                                </div>
                            </div>
                        </div>
                        <div class="chart-content">
                            <div class="linechart">
                                <div id="chartMain" class="chart_div" style="width: 688px; height:400px;"></div>
                            </div>
                            <div class="piechart">
                                <div id="chartPie" class="chart_div" style="width: 280px; height:400px;"></div>
                            </div>
                        </div>
                        <div class="statement-info-footer">
                            <h3 class="mb-0">使用聲明</h3>
                            <p class="mb-0">本圖表資料來源包含本公司成交，及政府實價登錄行情。</p>
                            <p class="mb-0">社區每月平均單價可能因該月成交房屋坪數大小、單價是否含車位等而上下波動，請一併參考上方詳細實價登錄列表。</p>
                        </div>
                    </div>
                </section>

                <section class="section-popular detail-popular" id="similarHouse">
                    <div class="container">
                        <h2 class="section-title d-flex align-items-center mb-2 mb-md-3">
                            <IconStar class="me-2"/>
                            社區待售物件及周邊房屋推薦
                        </h2>
                        <div class="popular-section-subtitle d-flex mb-4 align-items-center">
                            <h3 class="mb-0">
                                <span class="strong">{{ community.title }}</span>
                                <span class="tt2 mb-0">共有 <span class="text-danger">{{ community.similarHouseTotal }}筆</span> 待售房屋</span>
                            </h3>
                            <div class="ms-auto popular-arrow">
                                <button class="slick-prev detail-popular-prev customize mb-0">prev</button>
                                <button class="slick-next detail-popular-next customize mb-0">next</button>
                            </div>
                        </div>
                        <div class="popular-slider detail-popular-slider">
                            <template v-for="item in community.similarHouseList">
                                <HouseCard
                                    :siteName=siteName
                                    :about=about
                                    :item=item
                                    :communityName=community.title
                                ></HouseCard>
                            </template>
                            <!--                        <HouseCard v-for="(item, index) in 9" nametop="green-top"></HouseCard>-->
                            <!--                        <CommunityCard v-for="(item, index) in 1" :key="index" nametop='black-top'></CommunityCard>-->
                            <!--                        <CommunityCard v-for="(item, index) in 9" :key="index" nametop='green-top'></CommunityCard>-->
                        </div>
                    </div>
                </section>

                <section id="communityInfo" class="house-info-block pt-0">
                    <div class="container">
                        <h3 class="section_info-title d-flex align-items-center mb-3">
                            <i class="icon">
                                <img src="../assets/images/icon-files.svg" alt="" class="w-100">
                            </i> {{ community.title }}社區資料
                        </h3>
                        <div class="detail_content has-border">
                            <ul class="row mb-0">
                                <li class="col-md-6 item" v-if="community.address != ''">
                                    <h4 class="item_key">地址</h4>
                                    <p class="item_value">{{ community.address }}</p>
                                </li>
                                <li class="col-md-6 item" v-if="community.communityType != '-'">
                                    <h4 class="item_key">型態</h4>
                                    <p class="item_value">{{ community.communityType }}</p>
                                </li>
                                <li class="col-md-6 item" v-if="community.household != '-'">
                                    <h4 class="item_key">戶型</h4>
                                    <p class="item_value">{{ community.household }}戶</p>
                                </li>
                                <li class="col-md-6 item" v-if="community.age != '-'">
                                    <h4 class="item_key">屋齡</h4>
                                    <p class="item_value">{{ community.age }}年</p>
                                </li>
                                <li class="col-md-6 item" v-if="community.floor != '-'">
                                    <h4 class="item_key">樓層</h4>
                                    <p class="item_value">{{ community.floor }}F</p>
                                </li>
                                <li class="col-md-6 item" v-if="community.pattern != ''">
                                    <h4 class="item_key">格局</h4>
                                    <p class="item_value">{{ community.pattern }}</p>
                                </li>
                                <li class="col-md-6 item" v-if="community.ping != '-'">
                                    <h4 class="item_key">坪數</h4>
                                    <p class="item_value">{{ community.ping }}坪</p>
                                </li>
                                <li class="col-md-6 item" v-if="community.lotSize != ''">
                                    <h4 class="item_key">基地結構</h4>
                                    <p class="item_value">{{ community.lotSize }}坪</p>
                                </li>
                                <li class="col-md-6 item" v-if="community.mainStructure != ''">
                                    <h4 class="item_key">主要結構</h4>
                                    <p class="item_value">{{ community.mainStructure }}</p>
                                </li>
                                <li class="col-md-6 item" v-if="community.constructionMaterial != ''">
                                    <h4 class="item_key">外牆建材</h4>
                                    <p class="item_value">{{ community.constructionMaterial }}</p>
                                </li>
                                <li class="col-md-6 item" v-if="community.publicRatio != ''">
                                    <h4 class="item_key">公設</h4>
                                    <p class="item_value">{{ community.publicRatio }}<span v-if="community.publicRatio.indexOf('%') == -1">%</span></p>
                                </li>
                                <li class="col-md-6 item" v-if="community.managementFee != ''">
                                    <h4 class="item_key">管理費</h4>
                                    <p class="item_value">{{ community.managementFee }}元</p>
                                </li>
                                <li class="col-md-6 item" v-if="community.refuseDisposal != ''">
                                    <h4 class="item_key">垃圾處理</h4>
                                    <p class="item_value">{{ community.refuseDisposal }}</p>
                                </li>
                                <li class="col-md-6 item" v-if="community.guard != ''">
                                    <h4 class="item_key">警衛管理</h4>
                                    <p class="item_value">{{ community.guard }}</p>
                                </li>
                                <li class="col-md-6 item" v-if="community.accessibleFacility != ''">
                                    <h4 class="item_key">便利設施</h4>
                                    <p class="item_value">{{ community.accessibleFacility }}</p>
                                </li>
                            </ul>
                        </div>
                        <div class="detail_content has-border" v-if="community.parkingType != ''
                             || community.parkingCount != ''
                             || community.chargingDevice != ''">
                            <ul class="row mb-0">
                                <li class="col-md-6 item" v-if="community.parkingType != ''">
                                    <h4 class="item_key">車位類型</h4>
                                    <p class="item_value">{{ community.parkingType }}</p>
                                </li>
                                <li class="col-md-6 item" v-if="community.parkingCount != ''">
                                    <h4 class="item_key">車位數量</h4>
                                    <p class="item_value">{{ community.parkingCount }}</p>
                                </li>
                                <li class="col-md-6 item" v-if="community.chargingDevice != ''">
                                    <h4 class="item_key">充電設備</h4>
                                    <p class="item_value">{{ community.chargingDevice }}</p>
                                </li>
                            </ul>
                        </div>
                        <div class="detail_content has-border" v-if="community.builder != ''
                        || community.construction != ''
                        || community.architecturalDesign != ''">
                            <ul class="row mb-0">
                                <li class="col-md-6 item" v-if="community.builder != ''">
                                    <h4 class="item_key">建設公司</h4>
                                    <p class="item_value">{{ community.builder }}</p>
                                </li>
                                <li class="col-md-6 item" v-if="community.construction != ''">
                                    <h4 class="item_key">營造公司</h4>
                                    <p class="item_value">{{ community.construction }}</p>
                                </li>
                                <li class="col-md-6 item" v-if="community.architecturalDesign != ''">
                                    <h4 class="item_key">建築設計</h4>
                                    <p class="item_value">{{ community.architecturalDesign }}</p>
                                </li>
                            </ul>
                        </div>
                        <div class="detail_content has-border"
                             v-if="community.mrt != ''
                             || community.busStation != ''
                             || community.elementarySchoolDistrict != ''
                             || community.juniorHighSchoolDistrict != ''
                             || community.supermarket != ''
                             || community.park != ''">
                            <ul class="row mb-0">
                                <li class="col-md-6 item" v-if="community.mrt != ''">
                                    <h4 class="item_key">捷運站</h4>
                                    <p class="item_value">{{ community.mrt }}</p>
                                </li>
                                <li class="col-md-6 item" v-if="community.busStation != ''">
                                    <h4 class="item_key">公車站</h4>
                                    <p class="item_value">{{ community.busStation }}</p>
                                </li>
                                <li class="col-md-6 item" v-if="community.elementarySchoolDistrict != ''">
                                    <h4 class="item_key">國小學區</h4>
                                    <p class="item_value">{{ community.elementarySchoolDistrict }}</p>
                                </li>
                                <li class="col-md-6 item" v-if="community.juniorHighSchoolDistrict != ''">
                                    <h4 class="item_key">國中學區</h4>
                                    <p class="item_value">{{ community.juniorHighSchoolDistrict }}</p>
                                </li>
                                <li class="col-md-6 item" v-if="community.supermarket != ''">
                                    <h4 class="item_key">市場</h4>
                                    <p class="item_value">{{ community.supermarket }}</p>
                                </li>
                                <li class="col-md-6 item" v-if="community.park != ''">
                                    <h4 class="item_key">公園</h4>
                                    <p class="item_value">{{ community.park }}</p>
                                </li>
                            </ul>
                        </div>
                        <div class="detail_radius" v-if="community.communityFeature != ''">
                            <h4 class="title">社區特色</h4>
                            <p>{{ community.communityFeature }}</p>
                        </div>
                        <div class="detail_radius" v-if="community.lifeFunction != ''">
                            <h4 class="title">周邊機能</h4>
                            <p>{{ community.lifeFunction }}</p>
                        </div>
                        <div class="detail_radius" v-if="community.publicFacility != ''">
                            <h4 class="title">公共設施</h4>
                            <p>{{ community.publicFacility }}</p>
                        </div>
                    </div>
                </section>

                <section id="mapAnchor" class="house-info-block mb-lg-5" style="padding: 50px 0 40px;">
                    <div class="container">
                        <h3 class="section_info-title d-flex align-items-center">
                            <i class="icon">
                                <img src="../assets/images/icon-map.svg" alt="" class="w-100">
                            </i> 生活地圖
                        </h3>

                        <div class="row g-2 g-lg-3">
                            <div class="col-12 order-2 order-md-1 mt-0">
                                <nav class="nav nav-map my-3 mt-md-0">
                                    <ul>
                                        <li :class="'nav-item' + (facilityType == 1 ? ' active' : '')">
                                            <a href="javascript:;" class="nav-link" @click="facilityType = 1">
                                                <i class="icon">
                                                    <IconFood/>
                                                </i>
                                                <span class="text">飲食</span>
                                            </a>
                                        </li>
                                        <li :class="'nav-item' + (facilityType == 2 ? ' active' : '')">
                                            <a href="javascript:;" class="nav-link" @click="facilityType = 2">
                                                <i class="icon">
                                                    <IconBag/>
                                                </i>
                                                <span class="text">購物</span>
                                            </a>
                                        </li>
                                        <li :class="'nav-item' + (facilityType == 3 ? ' active' : '')">
                                            <a href="javascript:;" class="nav-link" @click="facilityType = 3">
                                                <i class="icon">
                                                    <IconForest/>
                                                </i>
                                                <span class="text">休閒</span>
                                            </a>
                                        </li>
                                        <li :class="'nav-item' + (facilityType == 4 ? ' active' : '')">
                                            <a href="javascript:;" class="nav-link" @click="facilityType = 4">
                                                <i class="icon">
                                                    <IconBus/>
                                                </i>
                                                <span class="text">交通</span>
                                            </a>
                                        </li>
                                        <li :class="'nav-item' + (facilityType == 5 ? ' active' : '')">
                                            <a href="javascript:;" class="nav-link" @click="facilityType = 5">
                                                <i class="icon">
                                                    <IconMoney/>
                                                </i>
                                                <span class="text">金融</span>
                                            </a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                            <div class="col-lg-8 order-1 order-md-2">
                                <div class="detail_content wkwuqsj">
                                    <div class="mapIframe">
                                        <div id="map" style="height: 350px;"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 order-3">
                                <div class="local_pin-lists">
                                    <div class="d-block d-sm-none local_pin-title">
                                        <template v-if="facilityType == 1">
                                            <i class="icon">
                                                <IconFood/>
                                            </i> 飲食
                                        </template>
                                        <template v-else-if="facilityType == 2">
                                            <i class="icon">
                                                <IconBag/>
                                            </i> 購物
                                        </template>
                                        <template v-else-if="facilityType == 3">
                                            <i class="icon">
                                                <IconForest/>
                                            </i> 休閒
                                        </template>
                                        <template v-else-if="facilityType == 4">
                                            <i class="icon">
                                                <IconBus/>
                                            </i> 交通
                                        </template>
                                        <template v-else-if="facilityType == 5">
                                            <i class="icon">
                                                <IconMoney/>
                                            </i> 金融
                                        </template>
                                    </div>
                                    <ul>
                                        <li class="item" v-for="facility in community.facilityList[facilityType]">
                                            <a href="javascript:;" class="item-link" @click="goto(facility)">
                                                <div class="d-none d-sm-block">{{ facility.name }}</div>
                                                <div class="d-block d-sm-none sm-item">
                                                    <div class="title">{{ facility.name }}</div>
                                                    <div class="distance">距離 {{ facility.distance }} m | 步行時間 {{ facility.time }} 分鐘</div>
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

<!--                <section id="nearCommunityList" class="section-popular detail-popular">-->
<!--                    <div class="container">-->
<!--                        <div class="d-flex">-->
<!--                            <h2 class="section-title d-flex align-items-center mb-3">-->
<!--                                <IconStar class="me-2"/>-->
<!--                                附近社區-->
<!--                            </h2>-->
<!--                            <div class="ms-auto popular-arrow">-->
<!--                                <button class="slick-prev nearby-popular-prev customize">prev</button>-->
<!--                                <button class="slick-next nearby-popular-next customize">next</button>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="popular-slider nearby-popular-slider">-->
<!--                            <template v-for="item in community.nearCommunityList">-->
<!--                                <NearbyCard :item="item"></NearbyCard>-->
<!--                            </template>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </section>-->

                <div class="modal fade sharetoModal question" id="questionModal" tabindex="-1" aria-labelledby="questionModalLabel"
                     aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h3>回報錯誤</h3>
                                <button type="button" class="btn-close close-error-reporting" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-lg-12 mx-auto">
                                        <div class="mb-3 row g-2">
                                            <label for="staticEmail" class="col-3 col-md-2 col-form-label pt-0">原因說明</label>
                                            <div class="col-9 col-md-10">
                                                <div class="form-check d-block d-md-inline-block me-0 me-md-4">
                                                    <input class="form-check-input" type="radio" name="reasonId" id="reasonId-1" value="1"
                                                           v-model="errorReporting.reasonId">
                                                    <label class="form-check-label" for="reasonId-1">
                                                        社區資料有誤
                                                    </label>
                                                </div>
                                                <div class="form-check d-block d-md-inline-block me-0 me-md-4">
                                                    <input class="form-check-input" type="radio" name="reasonId" id="reasonId-3" value="2"
                                                           v-model="errorReporting.reasonId">
                                                    <label class="form-check-label" for="reasonId-2">
                                                        成交資料有誤
                                                    </label>
                                                </div>
                                                <div class="form-check d-block d-md-inline-block me-0 me-md-4">
                                                    <input class="form-check-input" type="radio" name="reasonId" id="reasonId-3" value="3"
                                                           v-model="errorReporting.reasonId">
                                                    <label class="form-check-label" for="reasonId-3">
                                                        其他
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mb-3 row g-2">
                                            <label for="content" class="col-3 col-md-2 col-form-label">內容說明</label>
                                            <div class="col-9 col-md-10">
                                            <textarea class="form-control textarea-report" id="content" rows="5" placeholder="請詳細描述資料錯誤的部分，並附上正確資料及來源"
                                                      v-model="errorReporting.content"></textarea>
                                            </div>
                                        </div>
                                        <div class="btn-wrapper row g-2 mt-0 mt-sm-5">
                                            <div class="col-12 col-sm-6 mx-auto">
                                                <a href="javascript:;" class="btn btn-primary w-100" @click="storeErrorReporting">送出回饋</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade sharetoModal" id="sharetoModal" tabindex="-1" aria-labelledby="sharetoModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h3>分享物件</h3>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-md-9 mx-auto">
                                        <p class="text-center">點擊下方方框可自行編輯文案</p>
                                        <textarea id="copyWriting" cols="30" rows="10" class="share-word form-control">我發現一個很棒的社區，分享給你

【{{ community.title }}】
地址：{{ community.address }}
戶數：{{ community.household }}戶
屋齡：{{ community.age }}年
坪數：{{ community.ping }}坪
樓層：{{ community.floor }}樓

{{ community.branchName }}
{{ community.officeTel }}</textarea>
                                        <div class="btn-wrapper row mb-0 mb-md-4">
                                            <div class="col col-md-6 mx-auto">
                                                <a href="javascript:;" class="btn btn-outline-default w-100" @click="copyTextarea">複製文案</a>
                                            </div>
                                        </div>
                                        <div class="btn-wrapper row g-2 mt-0 mt-sm-2">
                                            <div class="col-12 col-sm-6">
                                                <a href="javascript:;" @click="openLink(community, 1)" class="btn btn-line w-100">
                                                    <div class="icon me-2">
                                                        <IconLine/>
                                                    </div>
                                                    Line 分享
                                                </a>
                                            </div>
                                            <div class="col-12 col-sm-6">
                                                <a href="javascript:;" @click="openLink(community, 2)" class="btn btn-fb w-100">
                                                    <div class="icon me-2">
                                                        <IconFacebook/>
                                                    </div>
                                                    Facebook 分享
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade sharetoModal actualmodal" id="actualModal2" tabindex="-1" aria-labelledby="actualModal2Label" aria-hidden="true">
            <!--            <div class="modal-dialog modal-dialog-centered">-->
            <div :class="'modal-dialog' + (width < 768 ? ' modal-fullscreen' : '')">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3>實價登錄完整資訊</h3>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body p-0">
                        <div class="cont">
                            <div class="cont-info-wrapper">
                                <p><span class="tt">成交年月</span> <span class="val">{{ modalGov.transactionDate }}</span></p>
                                <p><span class="tt">地址</span> <span class="val">{{ modalGov.address }}</span></p>
                                <p><span class="tt">型態</span> <span class="val">{{ modalGov.type == '' ? '-' : modalGov.type }}</span></p>
                                <p><span class="tt">總價</span> <span class="val">{{ modalGov.totalPrice }}萬</span></p>
                                <p><span class="tt">單價</span> <span class="val">{{ modalGov.averagePrice }}萬</span></p>
                                <p><span class="tt">總坪</span> <span class="val">{{ modalGov.totalPing }}坪</span></p>
                                <p><span class="tt">地坪</span> <span class="val">{{ modalGov.landPing == 0 ? '-' : modalGov.landPing + '坪' }}</span></p>
                                <p v-if="modalGov.isLand == 0"><span class="tt">屋齡</span> <span class="val">{{ modalGov.age }}年</span></p>
                                <p v-if="modalGov.isLand == 0"><span class="tt">樓層</span> <span class="val">{{ modalGov.floor }}</span></p>
                                <p><span class="tt">格局</span> <span class="val">{{ modalGov.pattern }}</span></p>
                                <p><span class="tt">備註</span> <span class="val">{{ modalGov.memo == '' ? '-' : modalGov.memo }}</span></p>
                                <div class="source">來源：內政部實價登錄</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HouseCard from '@/components/HouseCard.vue'
import CommunityCard from '@/components/CommunityCard.vue'
import NearbyCard from '@/components/NearbyCard.vue'
import IconEye from '@/components/icons/IconEye.vue'
import IconPlay from '@/components/icons/IconPlay.vue'
import IconStructure from '@/components/icons/IconStructure.vue'
import IconBus from '@/components/icons/IconBus.vue'
import IconBag from '@/components/icons/IconBag.vue'
import IconMoney from '@/components/icons/IconMoney.vue'
import IconFood from '@/components/icons/IconFood.vue'
import IconForest from '@/components/icons/IconForest.vue'
import IconPhone from '@/components/icons/IconPhone.vue'
import IconLine from '@/components/icons/IconLine.vue'
import IconFacebook from '@/components/icons/IconFacebook.vue'
import IconCalculator from '@/components/icons/IconCalculator.vue'
import IconShare from '@/components/icons/IconShare.vue'
import IconStar from '@/components/icons/IconStar.vue'
import IconClose from '@/components/icons/IconClose.vue'
import IconQuestion from '@/components/icons/IconQuestion.vue'
import IconPin from '@/components/icons/IconPin.vue'
import IconBuilding from '@/components/icons/IconBuilding.vue'
import IconSort from '@/components/icons/IconSort.vue'
import IconInfo from '@/components/icons/IconInfo.vue'
import {Toast} from 'bootstrap/dist/js/bootstrap.esm.min.js'
import {Tooltip} from 'bootstrap/dist/js/bootstrap.esm.min.js'
import {ScrollSpy} from 'bootstrap/dist/js/bootstrap.esm.min.js'

import {Bar} from 'vue-chartjs'

import "leaflet/dist/leaflet.css"
import L from 'leaflet'

export default {
    name: 'DetailCommunity',
    components: {
        HouseCard,
        CommunityCard,
        NearbyCard,
        IconEye,
        IconPlay,
        IconStructure,
        IconBus,
        IconBag,
        IconMoney,
        IconFood,
        IconForest,
        IconPhone,
        IconCalculator,
        IconLine,
        IconFacebook,
        IconShare,
        IconQuestion,
        IconPin,
        IconStar,
        IconClose,
        IconSort,
        IconInfo,
        IconBuilding
    },
    data() {
        return {
            siteName: '',
            about: {},
            width: 0,
            isShow: 0,
            community: {
                img: [],
                realPriceStatistics: {},
                realPriceList: [],
                similarHouseList: [],
                facilityList: [],
                nearCommunityList: [],
                roomsStatistics: {
                    total: {
                        3: {
                            monthS: '',
                            monthE: '',
                        },
                        6: {
                            monthS: '',
                            monthE: '',
                        },
                        12: {
                            monthS: '',
                            monthE: '',
                        },
                    },
                },
                isChart: 0,
            },
            errorReporting: {
                reasonId: 1,
                content: '',
            },
            checkedRange: 6,

            scroll: 0,
            infoOffsetTop: 0,

            map: '',
            leaflet: {
                zoom: 16,
                center: [22.612961, 120.304167],
                houseLatLng: [22.612961, 120.304167],
                url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
                attribution: `© <a href="http://osm.org/copyright">OpenStreetMap</a> contributors`,
                options: {
                    scrollWheelZoom: false,
                },
                icon: {
                    type: [
                        "/map_icon/pin-food.png",
                        "/map_icon/pin-bag.png",
                        "/map_icon/pin-forest.png",
                        "/map_icon/pin-bus.png",
                        "/map_icon/pin-money.png",
                    ],
                    shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
                    iconSize: [35, 45],
                    iconAnchor: [12, 41],
                    popupAnchor: [1, -34],
                    shadowSize: [41, 41]
                },
                markerList: [],
            },
            facilityType: 1,
            setStickyBroker: 'static',
            sort: {
                transactionDate: 0,
                totalPrice: 0,
                averagePrice: 0,
                totalPing: 0,
                landPing: 0,
                age: 0,
                pattern: 0,
            },
            lastSort: '',

            modalHouse: {},
            modalGov: {},
        }
    },
    beforeCreate() {
        let house = this;
        this.axios.get('/api/communities/detail/' + this.$route.params.uuid)
            .then(response => (
                    this.siteName = response.data.siteName,
                        this.about = response.data.about,
                        this.community = response.data.community,
                        // this.mortgage = this.house.mortgage,
                        this.meta = response.data.meta,
                        // this.initMap(this.house),
                        document.title = this.community.title + '-' + this.siteName,
                        $("meta[property='og:title']").attr("content", this.community.title + '-' + this.siteName),
                        document.getElementsByTagName('meta')["description"].content = this.siteName,
                        $("meta[property='og:description']").attr("content", this.siteName)
                )
            )
            .catch(function (error) {
                // handle error
                console.log(error);
                if (error.request.status == 301) {
                    location.replace(error.response.data.url);
                }
            })
            .then(() => {
                // always executed
                setTimeout(() => {
                    if (this.community.isChart == 1) {
                        this.setChart();
                    }

                    this.map = L.map('map').setView([this.community.lat, this.community.lng], this.leaflet.zoom);

                    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    }).addTo(this.map);

                    for (let type = 1; type <= 5; type++) {
                        for (let x = 0; x < this.community.facilityList[type].length; x++) {
                            let item = this.community.facilityList[type][x];

                            // L.marker([item.lat, item.lng], {title: item.subject}).addTo(this.map)
                            //     .bindPopup('A pretty CSS3 popup.<br> Easily customizable.')
                            //     .openPopup();
                            if (0) {
                                let markerItem = L.marker([item.lat, item.lng], {
                                    title: item.name, icon: L.icon({
                                        iconUrl: this.leaflet.icon.type[type],
                                        iconSize: [21, 25],
                                    })
                                })
                                markerItem.bindPopup(item.name, {
                                    offset: [0, 2],
                                    closeButton: false,
                                });
                                markerItem.addTo(this.map);

                                let marker = {
                                    type: 0,
                                    name: item.name,
                                    latLng: [item.lat, item.lng],
                                    markerItem: markerItem,
                                };
                                this.leaflet.markerList.push(marker);
                            }
                            // markerItem.on('click', function () {
                            //     alert('Clicked on a member of the group!');
                            // })
                            // markers.addLayer(markerItem);
                            if (x == 0) {
                                // this.map.setView([item.lat, item.lng], this.leaflet.zoom)
                            }
                        }
                    }

                    // this.map.addLayer(markers);

                    // 更多好房推薦
                    // $(".popular-slider").slick({
                    //     slidesToShow: 4,
                    //     slidesToScroll: 1,
                    //     infinite: true,
                    //     dots: false,
                    //     prevArrow: $('.popular-prev'),
                    //     nextArrow: $('.popular-next'),
                    //     responsive: [{
                    //         breakpoint: 992,
                    //         settings: {
                    //             slidesToShow: 2,
                    //             slidesToScroll: 1,
                    //             // centerMode: true,
                    //             // centerPadding: '250px',
                    //             variableWidth: true
                    //         }
                    //     }, {
                    //         breakpoint: 576,
                    //         settings: {
                    //             variableWidth: true,
                    //             slidesToShow: 1,
                    //             slidesToScroll: 1
                    //         }
                    //     }]
                    // });

                    $('.slider-for').slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                        dots: false,
                        fade: true,
                        asNavFor: '.slider-nav',
                        responsive: [{
                            breakpoint: 992,
                            settings: {
                                arrows: false,
                            }
                        }]
                    });
                    $('.slider-nav').slick({
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        asNavFor: '.slider-for',
                        arrows: false,
                        dots: false,
                        centerMode: true,
                        focusOnSelect: true,
                        responsive: [{
                            breakpoint: 768,
                            settings: {
                                variableWidth: true,
                            }
                        }]
                    });
                    $(".nearby-popular-slider").slick({
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        infinite: true,
                        dots: false,
                        prevArrow: $('.nearby-popular-prev'),
                        nextArrow: $('.nearby-popular-next'),
                        responsive: [{
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                                // centerMode: true,
                                // centerPadding: '250px',
                                variableWidth: true
                            }
                        }, {
                            breakpoint: 576,
                            settings: {
                                variableWidth: true,
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }]
                    });
                    $(".detail-popular-slider").slick({
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false,
                        prevArrow: $('.detail-popular-prev'),
                        nextArrow: $('.detail-popular-next'),
                        responsive: [{
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                // centerMode: true,
                                // centerPadding: '250px',
                                variableWidth: true
                            }
                        }, {
                            breakpoint: 576,
                            settings: {
                                variableWidth: true,
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }]
                    });

                    console.log(document.getElementById("realPrice").offsetTop)
                    this.infoOffsetTop = document.getElementById("realPrice").offsetTop;

                    setTimeout(() => {
                        this.isShow = 1;
                    }, 100);
                }, 1);
            });
    },
    created() {
        window.addEventListener('scroll', this.handleScroll);
    },
    methods: {
        openLink: function (community, type) {
            let link;
            if (type == 1) {
                if (this.width <= 767) {
                    link = community.shareLineMobile + document.getElementById("copyWriting").value.replaceAll("\n", "%0A") + '%0a' + community.url;
                } else {
                    link = community.shareLine + '&text=' + document.getElementById("copyWriting").value.replaceAll("\n", "%0A");
                }
            } else {
                link = community.shareFacebook;
            }
            window.open(link, "width=550, height=500");
        },
        setChart: function () {
            this.changeRange(this.checkedRange)
            // let house = this;
            //
            // $(window).on('resize', function () {
            //     if (myChart != null && myChart != undefined) {
            //         myChart.resize();
            //     }
            //
            //     if (pieChart != null && pieChart != undefined) {
            //         pieChart.resize();
            //     }
            // });
        },
        changeRange: function (range) {
            // return false;
            this.checkedRange = range;
            // return false;
            let chart = echarts.init(document.getElementById('chartMain'));
            // 指定图表的配置项和数据
            let option = {
                textStyle: {
                    width: 200
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#888'
                        }
                    }
                },
                legend: {
                    data: ['成交件數', '成交單價'],
                    bottom: 10,
                    left: 'center',
                },
                xAxis: [
                    {
                        type: 'category',
                        data: this.community.roomsStatistics.total[this.checkedRange].monthArray,
                        axisPointer: {
                            type: 'shadow'
                        },
                        axisLabel: {
                            fontSize: this.width < 767 ? 8 : 12,
                        },
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '',
                        min: this.community.roomsStatistics.total[this.checkedRange].minAverage,
                        max: this.community.roomsStatistics.total[this.checkedRange].maxAverage,
                        interval: this.community.roomsStatistics.total[this.checkedRange].intervalAverage,
                        axisLabel: {
                            formatter: '{value}萬',
                            fontSize: this.width < 767 ? 8 : 12,
                        }
                    },
                    {
                        type: 'value',
                        name: '',
                        min: 0,
                        max: this.community.roomsStatistics.total[this.checkedRange].maxCount,
                        interval: this.community.roomsStatistics.total[this.checkedRange].intervalCount,
                        axisLabel: {
                            formatter: '{value}件',
                            fontSize: this.width < 767 ? 8 : 12,
                        }
                    },
                ],
                series: [
                    {
                        name: '成交單價',
                        type: 'line',
                        // 此系列自己的调色盘。
                        color: [
                            this.community.roomsStatistics.colorA,
                            this.community.roomsStatistics.colorB
                            // '#DD4C27',
                            // '#759aa0',
                        ],
                        // yAxisIndex: 2,
                        smooth: true,
                        tooltip: {
                            valueFormatter: function (value) {
                                return value + ' 萬';
                            }
                        },
                        // data: [22, 25, 28, 33, 34, 26]
                        data: this.community.roomsStatistics.total[this.checkedRange].averageArray
                    },
                    {
                        name: '成交件數',
                        type: 'bar',
                        // 此系列自己的调色盘。
                        color: [
                            this.community.roomsStatistics.colorA,
                            this.community.roomsStatistics.colorB
                            // 'rgba(221,76,39,0.4)',
                            // '#759aa0',
                        ],
                        yAxisIndex: 1,
                        tooltip: {
                            valueFormatter: function (value) {
                                return value + ' 件';
                            }
                        },
                        data: this.community.roomsStatistics.total[this.checkedRange].countArray
                        // data: [80, 82, 87, 83, 89, 81]
                    },
                ]
            };
            // 使用刚指定的配置项和数据显示图表。
            chart.setOption(option);

            // PieChart
            let pie = echarts.init(document.getElementById('chartPie'));
            let optionPie = {
                tooltip: {
                    trigger: 'item',
                },
                legend: {
                    bottom: -5,
                    left: 'center',
                    width: 300,
                    selectedMode: false,
                    textStyle: {
                        padding: [5, 5, 5, 5]
                    },
                    formatter: function (name) {
                        let array = name.split("\n");
                        // if (array[1].length == 2) {
                        //     array[1] += '　';
                        // }
                        // if (array[1].length == 3) {
                        //     array[1] += ' ';
                        // }
                        for (let x = array[1].length; x < 4; x++) {
                            array[1] += ' ';
                        }
                        return array[0] + "\n成交占比 " + array[1];
                    }
                },
                series: [{
                    name: '房型',
                    type: 'pie',
                    // 此系列自己的调色盘。
                    color: [
                        this.community.roomsStatistics.colorA,
                        this.community.roomsStatistics.colorB,
                        this.community.roomsStatistics.colorC,
                        this.community.roomsStatistics.colorD,
                        // 'rgba(221,76,39,1)',
                        // 'rgba(221,76,39,0.64)',
                        // 'rgba(221,76,39,0.46)',
                        // 'rgba(221,76,39,0.2)',
                    ],
                    radius: ["30%", "75%"],
                    avoidLabelOverlap: false,
                    itemStyle: {
                        borderColor: '#fff',
                        borderWidth: 1
                    },
                    label: {
                        show: false,
                        position: 'center'
                    },
                    emphasis: {
                        label: {
                            show: true,
                            fontSize: '20'
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    data: [
                        {
                            value: this.community.roomsStatistics.total[this.checkedRange].room[0].count,
                            name: "1房\n" + this.community.roomsStatistics.total[this.checkedRange].room[0].percent + "%"
                        },
                        {
                            value: this.community.roomsStatistics.total[this.checkedRange].room[1].count,
                            name: "2房\n" + this.community.roomsStatistics.total[this.checkedRange].room[1].percent + "%"
                        },
                        {
                            value: this.community.roomsStatistics.total[this.checkedRange].room[2].count,
                            name: "3房\n" + this.community.roomsStatistics.total[this.checkedRange].room[2].percent + "%"
                        },
                        {
                            value: this.community.roomsStatistics.total[this.checkedRange].room[3].count,
                            name: "4房(含)以上\n" + this.community.roomsStatistics.total[this.checkedRange].room[3].percent + "%"
                        }
                    ]
                }]
            };
            pie.setOption(optionPie);

            $(window).on('resize', function () {
                if (chart != null && chart != undefined) {
                    chart.resize();
                }

                if (pie != null && pie != undefined) {
                    pie.resize();
                }
            });
        },
        storeErrorReporting: function () {
            if (this.errorReporting.content == '') {
                alert('請輸入回報內容！');
                return false;
            }
            let param = {
                reasonId: this.errorReporting.reasonId,
                content: this.errorReporting.content,
            }
            this.axios.post('/api/communities/error_reporting/' + this.community.id, param)
                .then(response => (
                    $('.close-error-reporting').click(),
                        this.errorReporting.content = ''
                ))
                .catch(function (error) {
                    // handle error
                    console.log(error);
                })
                .then(function () {
                    var myAlert = document.getElementById('toastErrorReporting'); //select id of toast
                    var bsAlert = new Toast(myAlert); //inizialize it
                    bsAlert.show(); //show it
                    console.log(bsAlert)
                    // always executed
                });
        },
        copyTextarea: function () {
            let copyText = document.getElementById("copyWriting");
            copyText.select();
            copyText.setSelectionRange(0, 99999);
            document.execCommand("copy");

            var myAlert = document.getElementById('toastNotice'); //select id of toast
            var bsAlert = new Toast(myAlert); //inizialize it
            bsAlert.show(); //show it
            console.log(bsAlert)
            // alert("已複製到剪貼簿");
        },
        goto: function (facility) {
            //重新定位地圖位置與標記點位置
            for (let x = 0; x < this.leaflet.markerList.length; x++) {
                if (facility.name == this.leaflet.markerList[x].name) {
                    this.leaflet.markerList[x].markerItem.openPopup()
                    this.map.setView(L.latLng(facility.lat, facility.lng), this.leaflet.zoom);
                    break;
                }
            }
        },
        handleScroll: function (event) {
            this.scroll = window.scrollY;
        },
        setShow: function () {
            // console.log(this.scroll)
            // console.log(this.infoOffsetTop)
            let stickyZone = document.getElementById('stickyZone')
            let width = $(window).width()
            if (width <= 991) {
                this.setStickyBroker = 'static';
            }
            if (width > 991 && stickyZone.getBoundingClientRect().top < 60 && stickyZone.getBoundingClientRect().bottom > 520) {
                this.setStickyBroker = 'fixed';
            } else if (width > 991 && stickyZone.getBoundingClientRect().bottom <= 520) {
                this.setStickyBroker = 'abs-bottom';
            } else {
                this.setStickyBroker = 'abs-top';
            }
        },
        realPriceSort: function (type) {
            console.log(type)
            if (this.lastSort != '' && this.lastSort != type) {
                this.sort[this.lastSort] = 0;
            }
            if (this.lastSort == type) {
                if (this.sort[this.lastSort] == 0 || this.sort[this.lastSort] == 2) {
                    this.sort[this.lastSort] = 1;
                } else {
                    this.sort[this.lastSort] = 2;
                }
            } else {
                this.sort[type] = 1;
            }
            this.lastSort = type;
            if (type == 'transactionDate' || type == 'pattern') {
                type += 'Compare';
            }
            if (this.sort[this.lastSort] == 1) {
                this.community.realPriceList.sort(function (a, b) {
                    return a[type] - b[type];
                });
            } else {
                this.community.realPriceList.sort(function (a, b) {
                    return b[type] - a[type];
                });
            }
        },
        showModal: function (house) {
            if (house.category == 2) {
                this.modalGov = house;
            } else {
                this.modalHouse = house;
            }
        },
    },
    mounted() {
        let community = this;
        let scrollSpy = new ScrollSpy(document.body, {
            target: '#stickySpy'
        })

        new Tooltip(document.body, {
            selector: "[data-toggle='tooltip']",
        })
        window.addEventListener("scroll", this.setShow);
        this.width = $(window).width();

        $("body").on("click", ".page-link", function (event) {
            let page = $(this).attr('page');
            community.axios.get('/api/communities/detail/' + community.$route.params.uuid + '?page=' + page)
                .then(response => (
                        community.community.realPriceList = response.data.community.realPriceList,
                            community.community.realPricePaginate = response.data.community.realPricePaginate
                    )
                )
                .catch(function (error) {
                    // handle error
                    console.log(error);
                })
            console.log(page)
            // house.search(page);
            //
            // setTimeout(() => {
            //     window.scrollTo(0, document.querySelector("#totalRecord").offsetTop);
            // }, 500)
        });
    },
    unmounted() {
        window.removeEventListener("scroll", this.setShow);
    }
}
</script>
